export default __webpack_public_path__ + "static/mockup-swimlanes-objective-11875e76371f9f0420c8078ed35f2d27.webp";